import {createSlice} from '@reduxjs/toolkit';

export const initialState = {
    loading: true,
    claimsList: [],
    claim: null,
    success: false,
}

export const claimSlice = createSlice({
    name: 'claims',
    initialState,
    reducers: {
        getClaimsList: (state, action) => {
            state.loading = true
        },
        claimsSuccess: (state, action) => {
            state.claimsList = action.payload
            state.loading = false
        },
        claimsFailed: (state, action) => {
            state.loading = false
        },
        getClaim: (state, action) => {
            state.loading = true
        },
        claimSuccess: (state, action) => {
            state.claim = action.payload
            state.loading = false
        },
        claimFailed: (state, action) => {
            state.loading = false
            state.claim = null
            state.success = false
        },
        createNewClaim: (state, action) => {},
        claimCreated: (state, action) => {
            state.success = true
        },
        claimCreationFailed: (state, action) => {},
        updateClaimStatus: (state, action) => {},
        claimStatusUpdateSuccess: (state, action) => {},
        claimStatusUpdateFailed: (state, action) => {},
        deleteClaim: (state, action) => {},
        claimDeletedSuccessfully: (state, action) => {
            state.claimsList = state.claimsList.filter((c) => c.id !== action.payload.id)
        },
        claimDeletionFailed: (state, action) => {},
        resetClaim: (state, action) => {
            state.loading = false
            state.claim = null
            state.success = false
        }
    }
})

export const {
    getClaimsList,
    claimsSuccess,
    claimsFailed,
    getClaim,
    claimSuccess,
    claimFailed,
    resetClaim,
    updateClaimStatus,
    claimStatusUpdateSuccess,
    claimStatusUpdateFailed,
    createNewClaim,
    claimCreated,
    claimCreationFailed,
    deleteClaim,
    claimDeletedSuccessfully,
    claimDeletionFailed,
} = claimSlice.actions;

export default claimSlice.reducer;
